/**
 * Gameplay and UI picture URLs. Every picture is drawn in code (render/toon/) at the size of
 * the PNG/SVG file it replaced.
 *
 * Nothing is drawn at import time: a URL is resolved (and its picture drawn) on first request.
 */
import { IMAGE_ART_KEYS, imageArtKey } from "../render/toon/art-catalog.js";
import { getToonArtUrl } from "../render/toon/art-registry.js";

var KNOWN = {};
IMAGE_ART_KEYS.forEach(function (key) { KNOWN[key] = true; });

/** @param {string} key */
export function gameImageUrl(key) {
  if (!KNOWN[key]) return "";
  return getToonArtUrl(imageArtKey(key));
}

/**
 * Pictures canvas draw sites read through `getCachedImage(gameImageUrl(key))` during play (Fall
 * objects, the catcher flask and its cracks and shards, the sea buoys). Warming them before the
 * first Fall frame keeps their drawing out of gameplay frames. DOM-only pictures (buttons,
 * chest, cursor, puzzle pieces) are not listed: the DOM decodes them itself when shown.
 */
export var GAMEPLAY_STATIC_IMAGE_KEYS = [
  "boulder",
  "gem",
  "shield",
  "flask",
  "flaskCrack",
  "flaskCrack2",
  "flaskShard1",
  "flaskShard2",
  "buoy",
];

/** URLs of GAMEPLAY_STATIC_IMAGE_KEYS (resolving them draws the pictures). */
export function gameplayStaticImageUrls() {
  return GAMEPLAY_STATIC_IMAGE_KEYS.map(gameImageUrl).filter(Boolean);
}

export function minimizeAimCursorUrl() {
  return gameImageUrl("minimizeAim");
}
